
export enum Gender {
  Female = "female",
  Male = "male",
  Other = "other",
  PreferNotToSay = "prefer_not_to_say",
}

export const GenderToText = (e: Gender): string => {
  switch (e) {
    case Gender.Male: return 'Male';
    case Gender.Other: return 'Other';
    case Gender.Female: return 'Female';
    case Gender.PreferNotToSay: return 'Prefer not to say';
  }
}
